import GraphqlBuilder from 'utils/request/graphql/builder'
import QueryBuildings from 'graphql/queries/QueryBuildings'
import HelperCollection from 'utils/helper-collection'
import _ from 'lodash'
import store from 'services/redux/store'
import QueryFloors from 'graphql/queries/QueryFloors'
import QueryRooms from 'graphql/queries/QueryRooms'
import QueryTables from 'graphql/queries/QueryTables'
import { managementConstants } from 'services/redux/management/constants'
import { setManagementMultiByGuid } from 'services/redux/management/actions'

export default class FetchManagementTimeslots {
	
	/**
	 * Fetch all the buildings and save them in redux
	 * @param kind
	 * @param subKind
	 * @param timeslotDay
	 * @param buildings
	 * @param floors
	 * @param rooms
	 * @param tables
	 * @param callbackSuccess
	 * @param callbackError
	 * @param callbackStart
	 * @param dispatchDataToStore
	 */
	static fetchAll = ( { kind = null, subKind = null, timeslotDay = [], buildings = true, floors = true, rooms = true, tables = true, callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = true } = {} ) => {
		const graphqlBuilder = new GraphqlBuilder();
		
		const variables = {
			kind: kind,
			sub_kind: subKind,
			timeslot_day: timeslotDay
		}
		
		if( buildings ) {
			graphqlBuilder.addQuery( 'buildings', QueryBuildings, variables )
		}
		
		if( floors ) {
			graphqlBuilder.addQuery( 'floors', QueryFloors, variables )
		}
		
		if( rooms ) {
			graphqlBuilder.addQuery( 'rooms', QueryRooms, variables )
		}
		
		if( tables ) {
			graphqlBuilder.addQuery( 'tables', QueryTables, {} )
		}
		
		graphqlBuilder.setOnStart( callbackStart );
		graphqlBuilder.setOnError( callbackError );

		graphqlBuilder.setOnSuccess( result => {
			const list = {};
			
			// Buildings
			if( buildings ) {
				list[ managementConstants.BUILDINGS ] = HelperCollection.filterWithoutGuid(
					_.get( result, ['buildings', 'buildings'], [] )
				);
			}
			
			if( floors ) {
				list[ managementConstants.FLOORS ] = HelperCollection.filterWithoutGuid(
					_.get( result, ['floors', 'floors'], [] )
				);
			}
			
			if( rooms ) {
				list[ managementConstants.ROOMS ] = HelperCollection.filterWithoutGuid(
					_.get( result, ['rooms', 'rooms'], [] )
				);
			}
			
			if( tables ) {
				list[ managementConstants.TABLES ] = HelperCollection.filterWithoutGuid(
					_.get( result, ['tables', 'tables'], [] )
				);
			}
			
			if( dispatchDataToStore ) {
				store.dispatch( setManagementMultiByGuid( list ))
			}

			if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
				callbackSuccess( list );
			}
		})
		

		graphqlBuilder.execute();
	}
}
